import React from 'react'
import { useToast } from './useToast'

const withToast = (WrappedComponent) => {
  const WithToast = (props) => {
    const toast = useToast()
    return <WrappedComponent {...props} toast={toast} />
  }
  WithToast.displayName = `withToast(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
  return WithToast
}

export default withToast
